import { HisWidgetBase } from './his-widget-base';

export class HisCalendarWidget extends HisWidgetBase<string> {
    kind = 'calendar';

    constructor( options: any = {} ) {
        super( options );
    }

    isWidgetModified(): boolean {
        if ( this.value === '' || this.value === null ) {
            this.value = undefined;
        }

        if ( this.originalValue === '' || this.originalValue === null ) {
            this.originalValue = undefined;
        }

        return this.value !== this.originalValue;
    }
}
